import axios from '@/util/axios'
import axiosNoError from '@/util/axios_no_error'
import { NEW_API_CONFIG, DEV_API_TOKEN } from '@/util/constants'
import { isFromAdminSystem } from '@/util/common'
import store from '@/store'
import { handleApiError as handleError } from '@/util/axios_common'

/**
 * マイリンク一覧API
 */
export const list = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/ML/001', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/ML/001', r).catch(handleError)
  }
}

/**
 * マイリンク登録API
 */
export const register = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/ML/002', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/ML/002', r).catch(handleError)
  }
}

/**
 * マイリンク更新
 */
export const update = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/ML/003', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/ML/003', r).catch(handleError)
  }
}

/**
 * マイリンク削除
 */
export const remove = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/ML/004', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/ML/004', r).catch(handleError)
  }
}

/**
 * マイリンク一括更新API
 */
export const updateInBulk = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/ML/005', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/ML/005', r).catch(handleError)
  }
}

/**
 * マイリンク並び替え
 */
export const changeOrder = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id
  
  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/ML/006', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/ML/006', r).catch(handleError)
  }
}
